import type { ComponentStyleConfig } from '@chakra-ui/react';

import { smallSemibold } from '../typography';

const TagComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    container: {
      ...smallSemibold(),
    },
  },
  variants: {
    empty: {},
  },
  defaultProps: {
    variant: 'empty',
  },
};

export default TagComponentStyle;
